import PropTypes from 'prop-types';
import React from 'react';
import CommonLayout from '../layouts/commonLayout';
import { ONE_SECOND_250MS } from '../../constants/time';

export default class CountdownView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPlaying: false,
        };
        this.interval = undefined;
        this.setUpTimer = this.setUpTimer.bind(this);
        this.tick = this.tick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isAvatarInitialized && this.props.isAvatarInitialized) {
            this.setUpTimer();
        }
        if (!prevProps.isPaused && this.props.isPaused) {
            this.pauseCountdown();
        }
        if (prevProps.isPaused && !this.props.isPaused) {
            this.resumeCountdown();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    setUpTimer() {
        if (this.interval === undefined) {
            // TODO: migrate to TimedView
            this.interval = setInterval(this.tick, ONE_SECOND_250MS);
            this.setState({
                remainingCount: this.props.initialCount,
                isPlaying: true,
            });
        }
    }

    tick() {
        if (!this.props.isPaused) {
            this.setState(prevState => ({
                remainingCount: prevState.remainingCount - 1,
            }), () => {
                if (this.state.remainingCount === 0) {
                    clearInterval(this.interval);
                    this.setState({
                        isPlaying: false,
                    }, () => {
                        this.props.onEndCounting();
                    });
                }
            });
        }
    }

    pauseCountdown() {
        this.setState({
            isPlaying: false,
        });
    }

    resumeCountdown() {
        this.setState({
            isPlaying: true,
        });
    }

    render() {
        const { countdownTitle, isPaused } = this.props;
        const { isPlaying, remainingCount } = this.state;
        return (
            <CommonLayout>
                <div>
                    {countdownTitle && <div className="countdown-title">{countdownTitle}</div>}
                    <div className={`countwheel ${isPlaying && !isPaused ? 'active' : ''}`}>
                        <div className="pie-wrapper">
                            <div className="countdown" />
                            <div className="pie spinner" />
                            <div className="pie filler" />
                            <div className="mask" />
                        </div>
                        <div className="ring" />
                        <div className="numberbox">{remainingCount}</div>
                    </div>
                </div>
            </CommonLayout>
        );
    }
}

CountdownView.propTypes = {
    countdownTitle: PropTypes.node,
    initialCount: PropTypes.number,
    onEndCounting: PropTypes.func.isRequired,
    isAvatarInitialized: PropTypes.bool.isRequired,
    cleanup: PropTypes.func,
    isPaused: PropTypes.bool.isRequired,
};

CountdownView.defaultProps = {
    countdownTitle: null,
    initialCount: 3,
    cleanup: () => {},
};
